<template>
  <template v-if="attachments.length">
    <div class="tw-text-2xl tw-font-medium tw-my-4">
      {{ copy.attachments }}
    </div>
    <div class="tw-flex tw-flex-wrap tw-gap-1">
      <SfDocumentPill
        v-for="attachment in attachments"
        :id="attachment.id"
        :key="attachment.id"
        :viewing-url="attachment.url"
        :allow-delete="false"
      >
        <template #left-icon>
          <i
            class="
              fa fa-file
              tw-text-xs tw-text-sf-neutral-light-2
              hover:tw-text-sf-gray-light
            "
          ></i>
        </template>
        <template #default>
          {{ attachment.filename }}
        </template>
      </SfDocumentPill>
    </div>
  </template>
</template>
<script setup lang="ts">
import SfDocumentPill from '@app/shared/vue/components/sf-document-pill.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

import type { Attachment } from '@app/application/client_meetings/types'

interface Props {
  attachments: Attachment[]
}

defineProps<Props>()

const I18n = useI18n()
const copy = {
  attachments: I18n.t('client_meetings.past.attachments'),
}
</script>
